import { storeUser } from "@/stores/user.js";
import $axios from "@/axios";

export default {
  //請求用戶資料
  get: async function () {
    await $axios
      .post("/api/admin/user_get_data.php")
      .then(function (res) {
        if (res.data.result == "pass") {
          storeUser.user = res.data.user;
        } else {
          console.log(res.data);
        }
      })
      .catch(function (err) {
        console.log(err);
      });
  },
  //更新頁首設定
  updateHeader: async function (pageHeader) {
    return await $axios.post("/api/admin/user_header_update.php", { pageHeader: pageHeader });
  },
};
